import styled from "styled-components";
import { px2rem } from "common/helpers/rem";

export const Wrapper = styled.div`
  width: 100vw;
  height: 104vw;
  position: relative;
`;

export const Content = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  margin: ${px2rem(25)} 0 ${px2rem(16)};
  font-size: ${px2rem(13)};
  font-weight: ${props => props.theme.weightBold};
  line-height: ${px2rem(20)};
  text-align: center;
  color: ${props => props.theme.white100};
`;

export const ReviewBoxList = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const ReviewBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  width: ${px2rem(224)};
  padding: ${px2rem(16)} ${px2rem(15)} ${px2rem(16)} ${px2rem(25)};
  border-radius: ${px2rem(8)};
  background-color: #eaf8ff;

  & + & {
    margin-top: ${px2rem(16)};
  }
`;

export const ReviewHeader = styled.div`
  margin-bottom: ${px2rem(4)};
`;

export const UserName = styled.span`
  font-size: ${px2rem(10)};
  font-weight: ${props => props.theme.weightBold};
  line-height: ${px2rem(14)};
  color: ${props => props.theme.grey900};
  margin-right: ${px2rem(8)};
`;

export const ReviewContent = styled.div`
  font-size: ${px2rem(13)};
  font-weight: ${props => props.theme.weightRegular};
  line-height: ${px2rem(20)};
  letter-spacing: ${px2rem(-0.1)};
`;

export const AppDownLoadButtonWrapper = styled.div`
  height: ${px2rem(40)};
  margin: ${px2rem(24)} 0;
`;

export const AppDownLoadButton = styled.div`
  width: ${px2rem(220)};
  height: 100%;
  margin: 0 auto;
  border-radius: ${px2rem(20)};
  box-shadow: 0 ${px2rem(4)} ${px2rem(16)} 0 rgba(31, 38, 42, 0.4);
  background-color: ${props => props.theme.white100};
  font-size: ${px2rem(13)};
  font-weight: ${props => props.theme.weightBold};
  line-height: ${px2rem(40)};
  text-align: center;
  color: ${props => props.theme.red700};
  cursor: pointer;
`;

export const RightMessageArrowWrapper = styled.div`
  position: absolute;
  top: ${px2rem(7)};
  right: ${px2rem(-8)};
`;

export const LeftMessageArrowWrapper = styled.div`
  transform: scaleX(-1);
  position: absolute;
  top: ${px2rem(7)};
  left: ${px2rem(-8)};
`;
